import { crmStatuses, crmStatusLabels } from "../../@types/sharedSchema";
import type { CrmStatus, CustomerSeriousness } from "../../@types/sharedSchema";

// The contacts-table status filter (kept under its historical id "customerSeriousness" so
// persisted localStorage filters/columns stay valid) now filters on the CRM v2 axes:
// one of the six lifecycle statuses, or "hot" for the crmIsHot 🔥 flag.
export type CrmStatusFilterValue = CrmStatus | "hot";

export const crmStatusFilterOptions: readonly CrmStatusFilterValue[] = [...crmStatuses, "hot"];

// Persisted filters may still hold a legacy Hebrew customerSeriousness value — normalize it
// to the closest CRM v2 filter so old saved filters keep working (mirrors the migration
// mapping in sharedSchema's mapSeriousnessToCrmStatus).
const legacySeriousnessToFilterValue: Record<CustomerSeriousness, CrmStatusFilterValue> = {
  "לא רציני": "irrelevant",
  "אין התאמה": "irrelevant",
  רציני: "in_progress",
  "לקוח חם": "hot",
  בעסקה: "hot",
  "נחתמה עסקה": "won"
};

export function normalizeCrmStatusFilterValue(raw: unknown): CrmStatusFilterValue | null {
  if (typeof raw !== "string" || !raw) return null;

  if ((crmStatusFilterOptions as readonly string[]).includes(raw)) {
    return raw as CrmStatusFilterValue;
  }

  return legacySeriousnessToFilterValue[raw as CustomerSeriousness] ?? null;
}

export function getCrmStatusFilterOptionLabel(
  value: CrmStatusFilterValue,
  translate: (key: string) => unknown
): string {
  if (value === "hot") return String(translate("contactsPage.crmStatus.hotLeadTooltip"));

  return crmStatusLabels[value];
}
